import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.less'],
})
export class ConfirmationComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
